(() => {
  if (window.mmCoffretContentsReady) return;
  window.mmCoffretContentsReady = true;
  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-mm-coffret-contents]').forEach(root => {
      if (root.dataset.ready) return;
      const form = document.getElementById(root.dataset.form);
      const data = root.querySelector('[data-mm-contents-map]');
      if (!form || !data) return;
      const maps = JSON.parse(data.textContent);
      root.dataset.ready = 'true';
      let current = '';
      let timer;
      const update = () => {
        const id = form.querySelector('[name="id"]')?.value;
        if (!root.isConnected || id === current || !maps[id]) return;
        current = id;
        const config = maps[id];
        const rows = config.items.split(';');
        root.querySelectorAll('.mm-coffret-contents__item').forEach((item, index) => {
          const values = rows[index]?.split('|');
          if (!values) return;
          const crop = item.querySelector('.mm-coffret-contents__crop');
          const img = crop.querySelector('img');
          const width = Number(values[3]);
          const height = Number(values[4] || values[3]);
          crop.style.setProperty('--mm-crop-ratio', width + '/' + height);
          crop.style.setProperty('--mm-scale-x', (10000 / width) + '%');
          crop.style.setProperty('--mm-scale-y', (10000 / height) + '%');
          crop.style.setProperty('--mm-crop-left', (-100 * Number(values[1]) / width) + '%');
          crop.style.setProperty('--mm-crop-top', (-100 * Number(values[2]) / height) + '%');
          if (img.getAttribute('src') !== config.source) {
            img.srcset = config.source + ' 900w';
            img.src = config.source;
          }
        });
      };
      const queue = () => { clearTimeout(timer); timer = setTimeout(update, 350); };
      const info = root.closest('product-info') || root.closest('.product__info-container');
      info?.addEventListener('change', queue);
      document.addEventListener('variant:change', queue);
      new MutationObserver(queue).observe(form, {childList:true,subtree:true,attributes:true,attributeFilter:['value']});
      update();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), {once:true});
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
